import types from './types';

function changeSystemLocale(locale) {
  return {
    type: types.CHANGE_SYSTEM_LOCALE,
    payload: {
      locale,
    },
  };
}

export default {
  changeSystemLocale,
};
